export const hasAttribute = (array, attribute) => array.find((e) => e.toLowerCase() === attribute.toLowerCase()) !== void 0;
export const optionableLabel = (field) => field.is_optional && field.type !== "boolean" ? ` ${field.human_name} (optional)` : field.human_name;
export default {
  hasAttribute,
  optionableLabel
};
